export const login = {
  "Mais facilidade na sua vida!": "More ease in your life!",
  "Nós facilitamos o seu ponto e seus benefícios para": "We facilitate your time tracking and benefits so that",
  "você focar no que realmente": "you can focus on what really",
  "importa!": "matters!",
  "O aplicativo MarQPonto está disponível para Android e iOS": "The MarQPonto app is available for Android and iOS",
  "Colaborador": "Employee",
  "Login": "Login",
  "Informe o seu e-mail para recuperar sua senha": "Enter your email to recover your password",
  "Esqueci minha senha": "Forgot my password",
  "Entrar": "Enter",
  "Eu sei minha senha": "I know my password",
  "Recuperar": "Recover",
  "Aviso": "Warning",
  "Usuário não encontrado no sistema.Se estiver tentando logar com seu e-mail, revise os dados e tente novamente.Se preferir, você também pode logar usando seu CPF.": "User not found in the system.If you are trying to log in with your email, review the data and try again.If you prefer, you can also log in using your CPF.",
  "Usuário não encontrado no sistema.Se estiver tentando logar com CPF, revise os dados e tente novamente.Você também pode logar usando seu e-mail.": "User not found in the system.If you are trying to log in with CPF, review the data and try again.You can also log in using your email.",
  "Você precisa preencher o Captcha para fazer login no sistema.": "You need to complete the Captcha to log in to the system.",
  "Sucesso!": "Success!"
};


// WEBPACK FOOTER //
// ./src/resources/enUS/login.js